import { render, staticRenderFns } from "./RevisionsView.vue?vue&type=template&id=59bd0f4e&"
import script from "./RevisionsView.vue?vue&type=script&lang=ts&"
export * from "./RevisionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports